import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  // const tenantService = inject(TenantService);

  const isAuthenticated = authService.isAuthenticated();
  const isUserData = authService.isUserData();

  const clearUserSession = () => {
    authService.clearUserProfile();
    // tenantService.updateProfile(null);
    authService.clearUserSessionData();
  };

  if (!isAuthenticated || !isUserData) {
    // If not authenticated, clear session. If just missing user data, maybe don't clear yet?
    // if (!isAuthenticated) {
    clearUserSession();
    // Redirect to login page with the return url
    authService.goToAuth(router.routerState.snapshot.url);
    // }

    return false;
  } else {
    return true;
  }
};
